export type MessageType =
  | 'appointment_confirmation'
  | 'appointment_reminder'
  | 'payment_reminder'
  | 'payment_received';

export interface SystemMessageTemplate {
  id: string;
  user_id: string;
  message_type: MessageType;
  template_content: string;
  created_at: string;
  updated_at: string;
}

export const MESSAGE_TYPE_LABELS: Record<MessageType, string> = {
  appointment_confirmation: 'Appointment Confirmation',
  appointment_reminder: 'Appointment Reminder',
  payment_reminder: 'Payment Reminder',
  payment_received: 'Payment Received Confirmation',
};

export const MESSAGE_TYPE_DESCRIPTIONS: Record<MessageType, string> = {
  appointment_confirmation: 'Sent when an appointment is scheduled',
  appointment_reminder: 'Sent before an appointment occurs',
  payment_reminder: 'Sent for pending payments',
  payment_received: 'Sent when payment is marked as paid',
};
